// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradeCategoryLeadTimesQueryVariables = Types.Exact<{
  filter: Types.TradeCategoryLeadTimeFilter;
}>;


export type TradeCategoryLeadTimesQuery = { __typename?: 'Query', tradeCategoryLeadTimes: Array<
    | { __typename?: 'TradeCategoryLeadTimeDefault', leadTimeInDays: number, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } }
    | { __typename?: 'TradeCategoryLeadTime', id: string, leadTimeInDays: number, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } }
  > };

export type TradeCategoryLeadTimesMetaDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TradeCategoryLeadTimesMetaDataQuery = { __typename?: 'Query', tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type SaveTradeCategoryLeadTimesMutationVariables = Types.Exact<{
  input: Types.SaveTradeCategoryLeadTimesInput;
}>;


export type SaveTradeCategoryLeadTimesMutation = { __typename?: 'Mutation', saveTradeCategoryLeadTimes: { __typename?: 'SaveTradeCategoryLeadTimesResult', tradeCategoryLeadTimes: Array<{ __typename?: 'TradeCategoryLeadTime', id: string, leadTimeInDays: number, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } }> } };

export type TradeCategoryLeadTimes_TradeCategoryLeadTimeFragment = { __typename?: 'TradeCategoryLeadTime', id: string, leadTimeInDays: number, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } };

export type TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLike_TradeCategoryLeadTimeDefault_Fragment = { __typename?: 'TradeCategoryLeadTimeDefault', leadTimeInDays: number, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } };

export type TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLike_TradeCategoryLeadTime_Fragment = { __typename?: 'TradeCategoryLeadTime', leadTimeInDays: number, tradeCategory: { __typename?: 'TradeCategory', id: string, name: string }, leadTimeFrequency: { __typename?: 'TimeFrequencyDetail', code: Types.TimeFrequency, name: string } };

export type TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLikeFragment =
  | TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLike_TradeCategoryLeadTimeDefault_Fragment
  | TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLike_TradeCategoryLeadTime_Fragment
;

export const TradeCategoryLeadTimes_TradeCategoryLeadTimeFragmentDoc = gql`
    fragment TradeCategoryLeadTimes_TradeCategoryLeadTime on TradeCategoryLeadTime {
  id
  leadTimeInDays
  tradeCategory {
    id
    name
  }
  leadTimeFrequency {
    code
    name
  }
}
    `;
export const TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLikeFragmentDoc = gql`
    fragment TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLike on TradeCategoryLeadTimeLike {
  leadTimeInDays
  tradeCategory {
    id
    name
  }
  leadTimeFrequency {
    code
    name
  }
}
    `;
export const TradeCategoryLeadTimesDocument = gql`
    query TradeCategoryLeadTimes($filter: TradeCategoryLeadTimeFilter!) {
  tradeCategoryLeadTimes(filter: $filter) {
    ...TradeCategoryLeadTimes_TradeCategoryLeadTime
    ...TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLike
  }
}
    ${TradeCategoryLeadTimes_TradeCategoryLeadTimeFragmentDoc}
${TradeCategoryLeadTimesLike_TradeCategoryLeadTimesLikeFragmentDoc}`;

/**
 * __useTradeCategoryLeadTimesQuery__
 *
 * To run a query within a React component, call `useTradeCategoryLeadTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeCategoryLeadTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeCategoryLeadTimesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTradeCategoryLeadTimesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables> & ({ variables: TradeCategoryLeadTimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>(TradeCategoryLeadTimesDocument, options);
      }
export function useTradeCategoryLeadTimesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>(TradeCategoryLeadTimesDocument, options);
        }
// @ts-ignore
export function useTradeCategoryLeadTimesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>;
export function useTradeCategoryLeadTimesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradeCategoryLeadTimesQuery | undefined, TradeCategoryLeadTimesQueryVariables>;
export function useTradeCategoryLeadTimesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>(TradeCategoryLeadTimesDocument, options);
        }
export type TradeCategoryLeadTimesQueryHookResult = ReturnType<typeof useTradeCategoryLeadTimesQuery>;
export type TradeCategoryLeadTimesLazyQueryHookResult = ReturnType<typeof useTradeCategoryLeadTimesLazyQuery>;
export type TradeCategoryLeadTimesSuspenseQueryHookResult = ReturnType<typeof useTradeCategoryLeadTimesSuspenseQuery>;
export type TradeCategoryLeadTimesQueryResult = Apollo.QueryResult<TradeCategoryLeadTimesQuery, TradeCategoryLeadTimesQueryVariables>;
export const TradeCategoryLeadTimesMetaDataDocument = gql`
    query TradeCategoryLeadTimesMetaData {
  tradeCategories {
    id
    name
  }
  markets {
    id
    name
  }
}
    `;

/**
 * __useTradeCategoryLeadTimesMetaDataQuery__
 *
 * To run a query within a React component, call `useTradeCategoryLeadTimesMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeCategoryLeadTimesMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeCategoryLeadTimesMetaDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTradeCategoryLeadTimesMetaDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>(TradeCategoryLeadTimesMetaDataDocument, options);
      }
export function useTradeCategoryLeadTimesMetaDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>(TradeCategoryLeadTimesMetaDataDocument, options);
        }
// @ts-ignore
export function useTradeCategoryLeadTimesMetaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>;
export function useTradeCategoryLeadTimesMetaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradeCategoryLeadTimesMetaDataQuery | undefined, TradeCategoryLeadTimesMetaDataQueryVariables>;
export function useTradeCategoryLeadTimesMetaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>(TradeCategoryLeadTimesMetaDataDocument, options);
        }
export type TradeCategoryLeadTimesMetaDataQueryHookResult = ReturnType<typeof useTradeCategoryLeadTimesMetaDataQuery>;
export type TradeCategoryLeadTimesMetaDataLazyQueryHookResult = ReturnType<typeof useTradeCategoryLeadTimesMetaDataLazyQuery>;
export type TradeCategoryLeadTimesMetaDataSuspenseQueryHookResult = ReturnType<typeof useTradeCategoryLeadTimesMetaDataSuspenseQuery>;
export type TradeCategoryLeadTimesMetaDataQueryResult = Apollo.QueryResult<TradeCategoryLeadTimesMetaDataQuery, TradeCategoryLeadTimesMetaDataQueryVariables>;
export const SaveTradeCategoryLeadTimesDocument = gql`
    mutation SaveTradeCategoryLeadTimes($input: SaveTradeCategoryLeadTimesInput!) {
  saveTradeCategoryLeadTimes(input: $input) {
    tradeCategoryLeadTimes {
      ...TradeCategoryLeadTimes_TradeCategoryLeadTime
    }
  }
}
    ${TradeCategoryLeadTimes_TradeCategoryLeadTimeFragmentDoc}`;
export type SaveTradeCategoryLeadTimesMutationFn = Apollo.MutationFunction<SaveTradeCategoryLeadTimesMutation, SaveTradeCategoryLeadTimesMutationVariables>;

/**
 * __useSaveTradeCategoryLeadTimesMutation__
 *
 * To run a mutation, you first call `useSaveTradeCategoryLeadTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradeCategoryLeadTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradeCategoryLeadTimesMutation, { data, loading, error }] = useSaveTradeCategoryLeadTimesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradeCategoryLeadTimesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradeCategoryLeadTimesMutation, SaveTradeCategoryLeadTimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradeCategoryLeadTimesMutation, SaveTradeCategoryLeadTimesMutationVariables>(SaveTradeCategoryLeadTimesDocument, options);
      }
export type SaveTradeCategoryLeadTimesMutationHookResult = ReturnType<typeof useSaveTradeCategoryLeadTimesMutation>;
export type SaveTradeCategoryLeadTimesMutationResult = Apollo.MutationResult<SaveTradeCategoryLeadTimesMutation>;
export type SaveTradeCategoryLeadTimesMutationOptions = Apollo.BaseMutationOptions<SaveTradeCategoryLeadTimesMutation, SaveTradeCategoryLeadTimesMutationVariables>;